// Voice upload — POST /voice (multipart audio). Returns {transcription, messages}.
// 402 → paywall (ApiError.status). Uses the shared client (FormData branch keeps
// Content-Type unset so the browser sets the multipart boundary).
import { api } from './client'
import type { ServerMessage } from '../types/api'

export interface VoiceUploadResponse {
  transcription?: string
  messages?: ServerMessage[]
}

// /voice is one synchronous request for the whole pipeline: emotion service +
// Silero VAD + STT + classifier + reply LLM. A ~1-minute clip measured 36-44s
// end-to-end — the client's default 30s abort killed it mid-flight and the user
// saw "Превышено время ожидания" while the backend was still working (Redmine
// 4445). 180s budget = frontend's own 120s recording cap + generous processing.
const VOICE_UPLOAD_TIMEOUT_MS = 180000

export const voiceApi = {
  upload: (blob: Blob, ext: string) => {
    const form = new FormData()
    form.append('audio', blob, `voice_message.${ext}`)
    return api.post<VoiceUploadResponse>('/voice', form, { timeout: VOICE_UPLOAD_TIMEOUT_MS })
  },
}
